var _desc, _defs, _circle, _circle2, _g, _g2, _g3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitorinsights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Crossed swords icon for Competitor Insights") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Two stylized crossed swords with a small shield accent, circular background.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bladeGrad",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D6E3",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hiltGrad",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D4AF37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8860B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 3,
    floodColor: "#000",
    floodOpacity: 0.18
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 96,
    fill: "#0f1724"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 60,
    r: 40,
    fill: "#ffffff",
    fillOpacity: 0.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 100 100)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 20,
    width: 8,
    height: 110,
    rx: 2,
    fill: "url(#bladeGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 26,
    width: 2,
    height: 98,
    rx: 1,
    fill: "#b8c7d3",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 120,
    width: 34,
    height: 8,
    rx: 3,
    fill: "url(#hiltGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 128,
    width: 12,
    height: 26,
    rx: 3,
    fill: "#2b2f36"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 158,
    r: 6,
    fill: "url(#hiltGrad)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 100 100)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 20,
    width: 8,
    height: 110,
    rx: 2,
    fill: "url(#bladeGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 26,
    width: 2,
    height: 98,
    rx: 1,
    fill: "#b8c7d3",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 120,
    width: 34,
    height: 8,
    rx: 3,
    fill: "url(#hiltGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 128,
    width: 12,
    height: 26,
    rx: 3,
    fill: "#2b2f36"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 158,
    r: 6,
    fill: "url(#hiltGrad)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L8 0 L4 18 L-4 18 L-8 0 Z",
    fill: "#ffffff",
    fillOpacity: 0.06,
    stroke: "#ffffff",
    strokeOpacity: 0.12,
    strokeWidth: 1
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 96,
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.06,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorinsights);
export default __webpack_public_path__ + "static/media/competitor insights.77764f59056ef71d6bfe534abdbb750d.svg";
export { ForwardRef as ReactComponent };